/*
 * Public API Surface of ngx-wrapper
 */

export * from './lib/ngx-wrapper.module';

export * from './lib/core/public-api';

export * from './lib/ngx-manage-layout/public-api';

export * from './lib/ngx-wrapper-shared/public-api';

export * from './lib/ngx-crud-layout/public-api';

export * from './lib/services/ngx-validation.service';


